// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_da-3";
export var flatBottomCorners = "_da-5";
export var productImage = "_da-0";
export var quantityContainer = "_da-2";
export var quantityHeader = "_da-6";
export var tooltip = "_da-1";
export var wrapAndEllipsesOverflow = "_da-4";